import { Edit, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { DepartmentFormFields } from './DepartmentForm';
import { normalizeShiftTimes } from './shiftTimes';

export const DepartmentEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic" transform={normalizeShiftTimes}>
    <SimpleForm toolbar={<MyToolbar resource="departments" />}>
      <MyFormContainer>
        <DepartmentFormFields isCreate={false} />
      </MyFormContainer>
    </SimpleForm>
  </Edit>
);

export default DepartmentEdit;
